module.exports = __webpack_public_path__ + "img/Proliferation-BRCA_GSE176078.a9746f66.png";